import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';

export interface UserIntentRequest {
  title: string;
  file_ids: string[];
  intent_metadata: Record<string, any>;
  pipeline_type: string;
  tags?: string[];
}

export const createUserIntent = async (data: UserIntentRequest) => {
  const response = await axios.post('/intents', data);
  return response.data;
};

export function useCreateIntent() {
  const { mutate: createIntent, isPending } = useMutation({
    mutationFn: createUserIntent,
  });

  return {
    createIntent,
    isIntentPending: isPending,
  };
}
